import React, { Component } from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import ReactSVG from "react-svg";
import StickyAlert from "./sticky-alert";
import { CSSTransition } from "react-transition-group";

const OuterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 99;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  padding: 10px 0 10px 10px;
  background: ${props => props.theme.colors.rojoBac};
  color: #fff;
  display: flex;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  display: flex;
`;

const Cta = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 1.2em;
`;

const SubCta = styled.div`
  font-size: 15px;
  line-height: 1em;
`;

const ButtonWrapper = styled.a`
  display: flex;
  flex: none;
  width: 75px;
  flex-basis: 75px;
  justify-items: center;
  align-content: center;
  text-align: center;
  border-left: solid 1px #fff;
  text-decoration: none;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  flex-direction: column;
  &:last-of-type {
    border-right: 0;
  }
  path,
  rect,
  polygon {
    fill: #fff;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex: none;
  width: 150px;
  font-size: 14px;
  position: relative;
  &.animated > a > div {
    -webkit-animation-name: wiggle;
    -ms-animation-name: wiggle;
    -ms-animation-duration: 800ms;
    -webkit-animation-duration: 800ms;
    -webkit-animation-iteration-count: 1;
    -ms-animation-iteration-count: 1;
    -webkit-animation-timing-function: ease-in-out;
    -ms-animation-timing-function: ease-in-out;
  }
`;

const IconContainer = styled.div`
  margin-bottom: ${props => (props.smaller ? ".2" : ".5")}em;
  width: 40px;
  height: 25px;
  margin: 0 auto 3px;
  ${breakpoint("tablet")`
    width: auto;
  `}
  svg {
    height: 25px;
  }
`;

const Button = ({ link, texto, icon, className, smaller, amex }) => (
  <ButtonWrapper
    href={link}
    smaller={smaller}
    amex={amex}
    className={className}
  >
    <IconContainer smaller={smaller}>{icon}</IconContainer>
    {texto}
  </ButtonWrapper>
);

const Icons = {
  whatsapp: (
    <ReactSVG
      path={`/images/iconos/contacto-whatsapp.svg`}
      alt={`Solicitala por WhatsApp`}
      svgStyle={{ height: 20, width: "auto" }}
    />
  ),
  formulario: (
    <ReactSVG
      path={`/images/iconos/contacto-formulario.svg`}
      alt={`Solicitala por Formulario`}
      svgStyle={{ height: 20, width: "auto" }}
    />
  )
};

class Sticky extends Component {
  state = {
    alert: false,
    animateButtons: false
  };

  retriggerAnimation() {
    setTimeout(() => this.setState({ animateButtons: true }), 300);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ animateButtons: true }), 1000);
  }

  toggleAlert() {
    this.setState({ alert: true });
    this.setState({ animateButtons: false }, this.retriggerAnimation());
  }

  hideAlert() {
    this.setState({ alert: false });
  }

  render() {
    const { multicanalidad, smaller, formulario, amex } = this.props;
    const { whatsapp, form } = multicanalidad;
    const formLink = formulario ? formulario : form;
    const { alert, animateButtons } = this.state;
    const Botones = {
      whatsapp: (
        <Button
          link="https://www.baccredomatic.com/es-cr/tarjetas/credito/whatsapp/solicitud"
          texto="WhatsApp"
          smaller={smaller}
          icon={Icons.whatsapp}
          amex={amex}
          className="multicanalidad-link-whatsapp"
        />
      ),
      form: (
        <Button
          link={formLink}
          texto="Formulario"
          smaller={smaller}
          icon={Icons.formulario}
          amex={amex}
          className="multicanalidad-link-form"
        />
      )
    };

    return (
      <OuterContainer>
        <Container>
          <div onClick={() => this.toggleAlert()} style={{ flex: 1 }}>
            <Cta>Solicitala aquí</Cta>
            <SubCta>Vos decidís el medio:</SubCta>
          </div>
          <ButtonsContainer className={animateButtons && `animated`}>
            {form && Botones.form}
            {whatsapp && Botones.whatsapp}
            <CSSTransition
              in={alert}
              timeout={150}
              classNames="sticky-alert"
              unmountOnExit
            >
              <StickyAlert
                mensaje="Presioná el ícono del medio por el que preferís solicitar tu tarjeta"
                hideAlert={() => this.hideAlert()}
              />
            </CSSTransition>
          </ButtonsContainer>
        </Container>
      </OuterContainer>
    );
  }
}

export default Sticky;
